var render = function() {
  var _obj, _obj$1
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.setFocus,
          expression: "setFocus"
        }
      ],
      staticClass: "place-input-component",
      attrs: { id: _vm.predictableId }
    },
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            _vm._b(
              {},
              "v-flex",
              ((_obj = {}), (_obj[_vm.inputColumns] = true), _obj),
              false
            ),
            [
              _c("v-text-field", {
                directives: [
                  {
                    name: "focus",
                    rawName: "v-focus",
                    value: _vm.hasAutomaticFocus,
                    expression: "hasAutomaticFocus"
                  }
                ],
                staticClass: "place-input",
                style: { "margin-bottom": _vm.mb + "px" },
                attrs: {
                  clearable: "",
                  flat: "",
                  box: _vm.box,
                  "hide-details": _vm.hideDetails,
                  hint: _vm.hint,
                  "persistent-hint": !_vm.hideDetails,
                  height: _vm.height,
                  disabled: _vm.disabled,
                  label: _vm.placeInputLabel
                },
                on: {
                  click: function($event) {
                    return _vm.setFocus(true)
                  },
                  focus: function($event) {
                    return _vm.inputFocused($event)
                  },
                  keyup: function($event) {
                    return _vm.changed($event)
                  },
                  "click:clear": function() {
                    return _vm.placeCleared(_vm.index)
                  }
                },
                scopedSlots: _vm._u(
                  [
                    _vm.searchAvailable
                      ? {
                          key: "append",
                          fn: function() {
                            return [
                              _vm.appendBtn === "search"
                                ? _c(
                                    "v-btn",
                                    {
                                      staticClass: "append-input-btn search",
                                      attrs: {
                                        icon: "",
                                        small: "",
                                        flat: "",
                                        title: _vm.$t(
                                          "placeInput.clickToSearchAndShowResultsOnTheMap"
                                        )
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.sendToSearchMode()
                                        }
                                      }
                                    },
                                    [
                                      _c("v-icon", { attrs: { left: "" } }, [
                                        _vm._v("search")
                                      ])
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          },
                          proxy: true
                        }
                      : null,
                    {
                      key: "append-outer",
                      fn: function() {
                        return [
                          _vm.appendBtn === "map"
                            ? _c(
                                "v-btn",
                                {
                                  directives: [
                                    {
                                      name: "smart-tooltip",
                                      rawName: "v-smart-tooltip",
                                      value: {
                                        show: _vm.showInputPickPlaceTooltip,
                                        text: _vm.$t(
                                          "placeInput.clickOnTheMapBtnToPickAPlace"
                                        ),
                                        position: "bottom",
                                        dark: true,
                                        showOnce: true,
                                        name: "pickAPlaceOnTheMap"
                                      },
                                      expression:
                                        "{show: showInputPickPlaceTooltip, text: $t('placeInput.clickOnTheMapBtnToPickAPlace'), position: 'bottom', dark: true, showOnce: true, name: 'pickAPlaceOnTheMap'}"
                                    }
                                  ],
                                  staticClass: "append-input-btn",
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    flat: "",
                                    title: _vm.$t(
                                      "placeInput.clickOnTheMapBtnToPickAPlace"
                                    )
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.pickPlaceClick($event)
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", { attrs: { left: "" } }, [
                                    _vm._v("map")
                                  ])
                                ],
                                1
                              )
                            : _vm._e()
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  true
                ),
                model: {
                  value: _vm.model.placeName,
                  callback: function($$v) {
                    _vm.$set(_vm.model, "placeName", $$v)
                  },
                  expression: "model.placeName"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.iconsBtnCounter > 0
            ? _c(
                "v-flex",
                _vm._b(
                  { staticClass: "input-btn-group" },
                  "v-flex",
                  ((_obj$1 = {}), (_obj$1[_vm.iconsColumns] = true), _obj$1),
                  false
                ),
                [
                  _vm.deleteAvailable && _vm.$mdAndUpResolution
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "input-btn",
                          class: { small: _vm.$mdAndUpResolution },
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              return _vm.removePlaceInput()
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "input-icon",
                              attrs: { title: _vm.$t("placeInput.removeInput") }
                            },
                            [_vm._v("delete")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.directIsAvailable && _vm.$mdAndUpResolution
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "input-btn",
                          class: { small: _vm.$mdAndUpResolution },
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              return _vm.toggleDirect()
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "input-icon",
                              attrs: {
                                color: _vm.localModel.direct
                                  ? "primary"
                                  : "dark",
                                title: _vm.$t("placeInput.toggleDirect")
                              }
                            },
                            [_vm._v("settings_ethernet")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.directionsAvailable
                    ? _c(
                        "v-btn",
                        {
                          directives: [
                            {
                              name: "smart-tooltip",
                              rawName: "v-smart-tooltip",
                              value: {
                                show: _vm.directionsButtonTooltip,
                                text: _vm.$t("placeInput.goToDirectionsMode"),
                                position: _vm.directionsButtonTooltipPosition,
                                dark: true,
                                showOnce: true,
                                name: "useDirectionsButton"
                              },
                              expression:
                                "{show: directionsButtonTooltip, text: $t('placeInput.goToDirectionsMode'), position: directionsButtonTooltipPosition, dark: true, showOnce: true, name: 'useDirectionsButton'}"
                            }
                          ],
                          staticClass: "input-btn",
                          class: { small: _vm.$mdAndUpResolution },
                          attrs: { flat: "", id: _vm.getNewGuid("directions") },
                          on: {
                            click: function($event) {
                              return _vm.startDirections()
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "input-icon",
                              attrs: {
                                title: _vm.$t("placeInput.directions"),
                                color: "dark",
                                large: _vm.$lowResolution
                              }
                            },
                            [_vm._v("directions")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.switchCoordsAvailable &&
                  (_vm.$mdAndUpResolution || _vm.single)
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "input-btn switch-coords",
                          class: { small: _vm.$mdAndUpResolution },
                          attrs: { flat: "" },
                          on: {
                            click: function($event) {
                              return _vm.switchCoords()
                            }
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "input-icon",
                              attrs: {
                                title: _vm.$t("placeInput.switchCoords"),
                                color: "dark",
                                large: _vm.$lowResolution
                              }
                            },
                            [_vm._v("compare_arrows")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.placeMenuAvailable
                    ? _c(
                        "v-menu",
                        {
                          staticClass: "floating-menu",
                          attrs: {
                            transition: "slide-y-transition",
                            "close-on-click": true,
                            "close-on-content-click": true,
                            bottom: ""
                          },
                          model: {
                            value: _vm.placeInputFloatingMenu,
                            callback: function($$v) {
                              _vm.placeInputFloatingMenu = $$v
                            },
                            expression: "placeInputFloatingMenu"
                          }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "floating-menu-activator no-padding",
                              attrs: { slot: "activator", flat: "" },
                              slot: "activator"
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "input-icon",
                                  staticStyle: { "font-size": "29px" },
                                  attrs: {
                                    title: _vm.$t(
                                      "placeInput.openInputOptions"
                                    ),
                                    color: "dark",
                                    large: ""
                                  }
                                },
                                [_vm._v("more_vert")]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-list",
                            {
                              staticClass: "input-pop-up-list",
                              staticStyle: { background: "white" },
                              attrs: { light: "" }
                            },
                            [
                              _vm.deleteAvailable
                                ? _c(
                                    "v-list-tile",
                                    {
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.removePlaceInput()
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-list-tile-title",
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "no-padding",
                                              attrs: { flat: "" }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    title: _vm.$t(
                                                      "placeInput.removeInput"
                                                    ),
                                                    color: "dark",
                                                    large: ""
                                                  }
                                                },
                                                [_vm._v("delete")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.switchCoordsAvailable
                                ? _c(
                                    "v-list-tile",
                                    [
                                      _c(
                                        "v-list-tile-title",
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "no-padding",
                                              attrs: { flat: "" },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.switchCoords()
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  attrs: {
                                                    title: _vm.$t(
                                                      "placeInput.switchCoords"
                                                    ),
                                                    color: "dark",
                                                    large: ""
                                                  }
                                                },
                                                [_vm._v("compare_arrows")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.directIsAvailable
                                ? _c(
                                    "v-list-tile",
                                    [
                                      _c(
                                        "v-list-tile-title",
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass: "input-btn",
                                              attrs: { flat: "" },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.toggleDirect()
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "input-icon",
                                                  attrs: {
                                                    color: this.model.direct
                                                      ? "primary"
                                                      : "dark",
                                                    title: _vm.$t(
                                                      "placeInput.toggleDirect"
                                                    )
                                                  }
                                                },
                                                [_vm._v("settings_ethernet")]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.showSuggestion
        ? _c(
            "div",
            {
              staticClass: "suggestions shadow",
              class: {
                scrollable:
                  _vm.$lowResolution && _vm.placeSuggestions.length > 3,
                "multiple-input": !_vm.single && _vm.$lowResolution
              }
            },
            [
              _c(
                "v-layout",
                { attrs: { row: "" } },
                [
                  _c(
                    "v-flex",
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs10: "", sm10: "", md11: "" } },
                            [
                              _vm.showBrowserLocationInPlacesList
                                ? _c(
                                    "v-list-tile",
                                    {
                                      attrs: {
                                        title: _vm.$t("placeInput.yourLocation")
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.setLocationFromBrowser()
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-list-tile-action",
                                        [_c("v-icon", [_vm._v("gps_fixed")])],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-list-tile-content",
                                        [
                                          _c(
                                            "v-list-tile-title",
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass:
                                                    "no-padding no-margin no-capitalize",
                                                  attrs: {
                                                    flat: "",
                                                    small: ""
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      $event.stopPropagation()
                                                      return _vm.setLocationFromBrowser()
                                                    }
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    " +
                                                      _vm._s(
                                                        _vm.$t(
                                                          "placeInput.yourLocation"
                                                        )
                                                      ) +
                                                      "\n                  "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("v-list-tile-sub-title", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "placeInput.fromYourBrowser"
                                                )
                                              )
                                            )
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { xs2: "", sm2: "", md1: "" } },
                            [
                              _c(
                                "div",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass:
                                        "close-suggestions no-margin no-padding",
                                      staticStyle: { width: "40px" },
                                      attrs: { flat: "", small: "", fab: "" },
                                      on: {
                                        click: function($event) {
                                          return _vm.setFocus(false)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "v-icon",
                                        {
                                          attrs: {
                                            title: _vm.$t("global.close"),
                                            large: _vm.$lowResolution
                                          }
                                        },
                                        [_vm._v("close")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.placeSuggestions, function(placeSuggested) {
                        return _c(
                          "v-list-tile",
                          {
                            key: placeSuggested.id,
                            staticClass: "place-suggestion",
                            class: {
                              "raw-coord": placeSuggested.rawCoordinate
                            },
                            attrs: { title: placeSuggested.placeName.trim() },
                            on: {
                              click: function($event) {
                                return _vm.selectSuggestion(placeSuggested)
                              }
                            }
                          },
                          [
                            _c(
                              "v-list-tile-action",
                              { staticClass: "hidden-sm-and-down" },
                              [
                                placeSuggested.properties.layer ===
                                  "locality" ||
                                placeSuggested.properties.layer === "city" ||
                                placeSuggested.properties.layer === "county"
                                  ? _c("v-icon", [_vm._v("location_city")])
                                  : _vm.showAreaIcon(placeSuggested)
                                  ? _c("img", {
                                      attrs: {
                                        alt:
                                          "Icon or image for suggested place",
                                        width: "25px",
                                        src: _vm.getImgSrc("countryIconImgSrc"),
                                        height: "auto"
                                      }
                                    })
                                  : _c("v-icon", [_vm._v("place")])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-list-tile-content",
                              [
                                _c(
                                  "v-list-tile-title",
                                  {
                                    attrs: {
                                      title: placeSuggested.placeName.trim()
                                    }
                                  },
                                  [
                                    _c("v-btn", {
                                      staticClass:
                                        "no-padding no-margin no-capitalize",
                                      staticStyle: {
                                        "min-width": "fit-content"
                                      },
                                      attrs: { flat: "", small: "" },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.highlightedName(
                                            placeSuggested.placeName
                                          )
                                        )
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.selectSuggestion(
                                            placeSuggested
                                          )
                                        }
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("v-list-tile-sub-title", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(
                                        _vm.getLayerTranslation(
                                          placeSuggested.properties.layer
                                        )
                                      ) +
                                      "\n              "
                                  ),
                                  placeSuggested.properties.locality
                                    ? _c("span", [
                                        _vm._v(
                                          " - " +
                                            _vm._s(
                                              placeSuggested.properties.locality
                                            ) +
                                            " "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  placeSuggested.properties.country
                                    ? _c("span", [
                                        _vm._v(
                                          " - " +
                                            _vm._s(
                                              placeSuggested.properties.country
                                            ) +
                                            " "
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticClass: "approximate-distance",
                                      attrs: {
                                        title: _vm.$t(
                                          "placeInput.approximateDistance"
                                        )
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                ~" +
                                          _vm._s(_vm.distance(placeSuggested)) +
                                          "\n                " +
                                          _vm._s(
                                            _vm.$t(
                                              "global.units." +
                                                _vm.$store.getters.mapSettings
                                                  .unit
                                            )
                                          ) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7cb71a1a", { render: render, staticRenderFns: staticRenderFns })
  }
}